import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  FormGroup,
  FormControl,
  Spinner,
  EmptyState,
  ControlLabel,
  SeachForm,
  ButtonCommonTheme,
} from "modules/theme";
import { Modal } from "react-bootstrap";
import { Column, Columns, Title } from "../styles/main";
import { ModalFooter } from "modules/theme";
import APIManager from "modules/common/apiManager";
import { Alert } from "modules/theme";
import styled from "styled-components";
const contextTypes = {
  __: PropTypes.func,
};

const ColumnContainer = styled.div`
  ${(props) => `height: calc(100% - ${!props.isAdded ? "118px" : "88px"});`}
  overflow: auto;
  padding: 20px;

  .column {
    background: #ffffff;
    box-shadow: 0px 4px 24px rgb(0, 0, 0, 0.05);
    border-radius: 20px;
    padding: 0px 20px 0 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .column-2 {
    background: #f2f2f2;
    padding-right: 20px;
    border-radius: 20px;
    height: 100%;
    border: 1px dashed #b1b1b1;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
  }

  .title {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: normal;
    display: flex;
    align-items: center;
    justify-content: space-between;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #010101;
    margin: 0;
    padding: 0;
    background: #fff;
    margin-top: 17px;
  }

  .arrow-style {
    background: #fff;
    padding: 5px;
    border-radius: 50px;
    color: #2b3c93;
    border: 1px solid #2b3c93;
    box-shadow: 0px 0px 20px rgb(0 0 0 / 20%);
  }

  .icons-div {
    position: absolute;
    left: 48%;
    z-index: 99;
    top: 35%;
  }

  .span-style {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: normal;
    display: flex;
    align-items: center;
    text-align: right;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #4860d9;
    margin: 0;
  }

  .ul-div {
    margin-top: 15px;
  }
`;

const LiStyle = styled.li`
  ${(props) =>
    `border: ${props.icon !== "add" ? "1px dashed #B1B1B1" : "1px solid #F2F2F2"
    } !important`};
  border-radius: 10px !important;
  background: #fff !important;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05) !important;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 15px;

  span {
    font-weight: 500;
  }
`;

class ChooserSelector extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.save = this.save.bind(this);
    this.renderNonSelected = this.renderNonSelected.bind(this);
    this.search = this.search.bind(this);
    this.itemSelected = this.itemSelected.bind(this);
    this.mAPI = new APIManager();
    this.timer = "";
    this.actualList = [];
    this.handleModalClose = this.handleModalClose.bind(this);
    this.state = {
      loading: false,
      isAdded: false,
      showHide: false,
      search: "",
      selectedLoader: false,
      nonSelectedLoader: false,
      elementId: props.elementId,
      selected: [],
      list: [],
      searchValue: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.elementId !== this.state.elementId) {
      this.setState({ elementId: nextProps.elementId });
      if (nextProps.elementId != "") {
        this.selectedElements(nextProps.elementId);
      }
    }
  }

  apiResponse(errorCode, data) {
    if (errorCode === 0) {
      let message = "File Successfully Updated.";
      message = data && data.message ? data.message : "Successfully updated";
      Alert.success(`${message}`);
      this.closeModal();
    } else {
      let message = data && data.message ? data.message : "Upload Error";
      Alert.error(`${message}`);
    }
  }
  nonSelectedElements(selected, searchText = "", elementId) {
    this.setState({ nonSelectedLoader: true });
    var that = this;
    let { searchUrl = "", searchProcess } = this.props;
    selected.map((data) => {
      searchUrl += "&excluded=" + data._id;
    });
    if (searchText) {
      searchUrl += "&search=" + searchText;
    }
    searchUrl = searchUrl.replace("<elementId>", elementId);
    this.mAPI.sendGetAPI(
      searchUrl,
      (data) => {
        let list = [];
        if (typeof searchProcess === "function") {
          list = searchProcess(data);
        }
        if (list) {
          that.setState({ list: list, nonSelectedLoader: false });
        }
      },
      (error, data) => {
        this.setState({ nonSelectedLoader: false, list: [] });
        if (data && data.message) {
          Alert.error(`${data.message}`);
        } else {
          Alert.error(`Something Wrong Happened!!`);
        }
      }
    );
  }
  selectedElements(elementId) {
    this.setState({
      selectedLoader: true,
      nonSelectedLoader: true,
      showHide: true,
    });
    var that = this;
    let { selectedUrl = "", selectedProcess } = this.props;
    this.actualList = [];
    if (selectedUrl) {
      selectedUrl = selectedUrl.replace("<elementId>", elementId);
      this.mAPI.sendGetAPI(
        selectedUrl,
        (data) => {
          this.setState({ selectedLoader: false });
          let list = [];
          if (typeof selectedProcess === "function") {
            list = selectedProcess(data);
          }
          if (list) {
            this.actualList = list;
            that.setState({ selected: list });
          }
          this.nonSelectedElements(list, "", elementId);
        },
        (error, data) => {
          this.setState({
            nonSelectedLoader: false,
            selectedLoader: false,
            selected: [],
          });
        }
      );
    } else {
      let list = [];
      if (list) {
        this.actualList = list;
        that.setState({ selected: list, selectedLoader: false });
      }
      this.nonSelectedElements(list, "", elementId);
    }
  }
  itemSelected() {
    let added = [],
      removed = [];
    this.actualList.map((data) => {
      if (!this.state.selected.some((e) => e._id === data._id)) {
        removed.push(data._id);
      }
    });
    this.state.selected.map((data) => {
      if (!this.actualList.some((e) => e._id === data._id)) {
        added.push(data._id);
      }
    });
    if (added.length || removed.length) {
      this.setState({ isAdded: true });
    } else {
      this.setState({ isAdded: false });
    }
  }

  handleModalClose() {
    this.setState({ searchValue: "" });
  }

  save(e) {
    e.preventDefault();
    this.setState({ loading: true });
    let _this = this;
    let { finalUrl = "", fetchData, elementId } = this.props;
    finalUrl = finalUrl.replace("<elementId>", elementId);
    let added = [],
      removed = [];
    this.actualList.map((data) => {
      if (!this.state.selected.some((e) => e._id === data._id)) {
        removed.push(data._id);
      }
    });
    this.state.selected.map((data) => {
      if (!this.actualList.some((e) => e._id === data._id)) {
        added.push(data._id);
      }
    });
    let formData = fetchData(added, removed);
    this.mAPI.sendPostAPI(
      `${finalUrl}`,
      formData,
      (data) => {
        Alert.success(`Updated Successfully.`);
        this.closeModal();
        if (typeof this.props.closeModal == "function") {
          this.handleModalClose();
          this.props.closeModal(true);
        }
        this.setState({ loading: false });
      },
      (errorCode, data) => {
        this.apiResponse(errorCode, data);
        this.setState({ loading: false });
      },
      "private",
      {},
      "PUT"
    );
  }
  search(e) {
    const value = e.target.value;
    const reg = /^[a-zA-Z0-9_ @]*$/;
    if (reg.test(value)) {
      if (value.trim() || value === "") {
        const _this = this;
        _this.setState({ search: value, searchValue: value });
        if (_this.timer) clearTimeout(_this.timer);
        _this.timer = setTimeout(() => {
          _this.nonSelectedElements(
            this.state.selected,
            this.state.search,
            this.state.elementId
          );
        }, 500);
      }
    }
  }

  handleModal() {
    this.setState(
      {
        showHide: !this.state.showHide,
      },
      () => {
        if (this.state.showHide === false) {
          this.handleModalClose();
          this.props.closeModal && this.props.closeModal();
        }
      }
    );
  }
  closeModal() {
    this.setState({ showHide: false, searchValue: "" });
    this.props.closeModal && this.props.closeModal();
  }
  openModal() {
    this.setState({ showHide: true });
  }
  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }
  handleChange(type, data) {
    const { selected, list } = this.state;
    let _this = this;
    if (type === "add") {
      let list = [];
      try {
        list = this.state.list.filter((el) => {
          return el._id !== data._id;
        });
      } catch (error) { }
      this.setState({ selected: [data, ...selected], list: list });
    } else {
      let shouldEnterList = list;
      if (
        data.name.toLowerCase().includes(this.state.searchValue.toLowerCase())
      ) {
        shouldEnterList = [...list, data];
      }
      this.setState({
        selected: selected.filter((item) => item !== data),
        list: shouldEnterList,
      });
    }
    setTimeout(() => {
      _this.itemSelected();
    }, 200);
  }
  renderRow(data, icon) {
    if (icon === "add" && this.state.selected.some((e) => e._id === data._id)) {
      return null;
    }

    const isLoading = this.state.nonSelectedLoader || this.state.selectedLoader;

    return (
      <LiStyle
        style={{ width: "100%", minWidth: "150px" }}
        icon={icon}
        className={icon === "add" ? "add" : "remove"}
        onClick={!isLoading ? () => this.handleChange(icon, data) : null}
      >
        {data.name}
        <span class="material-symbols-outlined">
          {icon === "add" ? "add_circle" : "remove"}
        </span>
      </LiStyle>
    );
  }
  renderNonSelected(list) {
    if (this.state.nonSelectedLoader) {
      return <Spinner />;
    } else if (list.length) {
      return (
        <ul style={{ height: "auto" }} className="ul-div">
          {list.map((data) => this.renderRow(data, "add"))}
        </ul>
      );
    }
    return <EmptyState text="No items" icon="list-2" />;
  }
  renderSelected(selected) {
    if (this.state.selectedLoader) {
      return <Spinner />;
    } else if (selected.length) {
      return (
        <ul style={{ marginTop: "11px", height: "auto" }}>
          {selected.map((data) => this.renderRow(data, "minus-circle"))}
        </ul>
      );
    }
    return <EmptyState text="No items added" icon="list-2" />;
  }

  render() {
    const { modalSize = "lg", showUpdateButton = true } = this.props;
    return (
      <Modal
        size={modalSize}
        show={this.state.showHide}
        // dialogClassName='chooser-selector-dialog'
        dialogClassName="modal-800w"
        onHide={() => {
          this.closeModal();
        }}
      >
        <Modal.Dialog bsClass="custom-modal-dialog-for-chooser-selector">
          <Modal.Header>
            <Modal.Title>{this.props.name ? this.props.name : ""}</Modal.Title>
            <span
              onClick={this.closeModal}
              style={{ cursor: "pointer" }}
              className="material-symbols-outlined"
            >
              cancel
            </span>
          </Modal.Header>
          <Modal.Body bsClass=" chooserSelector-modal-body modal-body ">
            <form
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
              onSubmit={(e) => this.save(e)}
              className=" d-flex flex-column "
            >
              <ColumnContainer isAdded={this.state.isAdded}>
                <Columns style={{ height: "100%" }}>
                  <Column className="column">
                    <Title
                      className="title flex-shrink-0"
                      style={{ margin: 0, padding: 13 }}
                    >
                      {this.props.text ? this.props.text : ""}
                    </Title>
                    <SeachForm className="w-100 search" style={{ margin: 0 }}>
                      <FormControl
                        style={{ width: "100%" }}
                        type="text"
                        placeholder={"Search Here"}
                        onChange={(e) => this.search(e)}
                        value={this.state.searchValue}
                      />
                      <span class="material-symbols-outlined">search</span>
                    </SeachForm>
                    {this.renderNonSelected(this.state.list)}
                  </Column>
                  <div className="icons-div">
                    <span className="arrow-style material-symbols-outlined icon">
                      arrow_back
                    </span>
                    <br />
                    <span className="arrow-style material-symbols-outlined icon">
                      arrow_forward
                    </span>
                  </div>
                  <Column className="column-2">
                    <Title
                      className="title flex-shrink-0"
                      style={{ background: "none" }}
                    >
                      Responders
                      <span className="span-style">
                        {this.state.selected.length}
                      </span>
                    </Title>
                    {/* <div className='w-100 m-0'> */}
                    {this.renderSelected(this.state.selected)}
                    {/* </div> */}
                  </Column>
                </Columns>
              </ColumnContainer>
              <ModalFooter>
                {!this.state.isAdded && (
                  <p className="text-danger text-right">
                    We didn't found any changes in mapping
                  </p>
                )}
                <ButtonCommonTheme
                  type="greyModalBtn"
                  onClick={() => this.handleModal()}
                >
                  Cancel
                </ButtonCommonTheme>
                {showUpdateButton && (
                  <ButtonCommonTheme type="blueModalBtn" btnType="submit" isLoading={this.state.loading}>
                    Update
                  </ButtonCommonTheme>
                )}
              </ModalFooter>
            </form>
          </Modal.Body>
        </Modal.Dialog>
      </Modal>
    );
  }
}
ChooserSelector.contextTypes = contextTypes;
export default ChooserSelector;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/ChooserSelector.js